import type { Effect } from '@redux-saga/types';
import { createConfigurable } from '@peloton/config-singleton';

type Config = {
  getAnalyticsPropsForStartWorkout: (
    knownAnalyticsProps: Record<string, any>,
  ) => IterableIterator<Effect | Record<string, any>>;
};

export const { config, updateConfig } = createConfigurable<Config>({
  getAnalyticsPropsForStartWorkout: function* (props: Record<string, any>) {
    return props;
  },
});
